import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Alert from 'components/Alert';
import * as React from 'react';
import { useHistory } from 'react-router-dom';

import { useStyles } from './styles';

type HeaderProps = {
  title: string;
};

function Header({ title }: HeaderProps) {
  const classes = useStyles();
  const history = useHistory();

  const handleOpenConfirm = React.useCallback(async () => {
    const confirm = await Alert.confirm({
      message: 'Caso clique em continuar, perderá todas as informações preenchidas. Deseja continuar?',
      buttonOk: 'Continuar',
      small: true,
    });

    if (!confirm) return;

    history.goBack();
  }, [history]);

  return (
    <header className={classes.container}>
      <Typography variant='h4' component='h1'>
        {title}
      </Typography>
      <Button id='subscription-plan-back-button' onClick={handleOpenConfirm} variant='outlined'>
        Voltar
      </Button>
    </header>
  );
}

export { Header };
